<template>
	<v-row>
		<v-checkbox
				:error-messages="$props.error"
				:label="$props.label"
				class="ml-2 mr-2"
				v-model="inputValue"></v-checkbox>
	</v-row>
</template>

<script>
	export default {
		name: "CheckBox",
		props: ['value', 'label','error'],
		data() {
			return {
				inputValue: this.$props.value
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
</style>
